import {DEFAULT_SORT_COL} from '../common/constants';
import {
    PAGINATION_BEGIN_PAGE_COUNT,
    PAGINATION_CURRENT_AROUND_PAGE_COUNT,
    PAGINATION_DEFAULT_PAGE_SIZE,
    PAGINATION_FIRST_PAGE
} from '../components/table-pagination/pagination-constants';
import {SortDirection} from '../enums/sort-direction';
import {CommonListFilter} from '../models/filters/common-list-filter';
import {FilterCriterion} from '../models/filters/filter-criterion';

/**
 *  To display the first N pages
 */
export const DEFAULT_PAGE_REQUESTS = PAGINATION_BEGIN_PAGE_COUNT + PAGINATION_CURRENT_AROUND_PAGE_COUNT * 2;

/**
 * A factory for instantiating with default values ListFilter
 */
export class ListFilterFactory {

    public static createWithSearchFields(
        filters: FilterCriterion[],
        sortColumn: string = DEFAULT_SORT_COL,
        sortDirection: SortDirection = SortDirection.ASC,
        pageSize: number = PAGINATION_DEFAULT_PAGE_SIZE
    ): CommonListFilter {
        return {
            filters,
            pageIndex: PAGINATION_FIRST_PAGE,
            pageSize,
            sortColumn,
            sortDirection: sortColumn && sortDirection,
            pageCount: DEFAULT_PAGE_REQUESTS
        };
    }

}
